<template>
  <div class="container shadow">
    <h1>&bull; SKICKA ETT MEDDELANDE &bull;</h1>
    <div class="underline"></div>
    <div class="icon_wrapper"></div>
    <form @submit.prevent="onSubmit">
      <div class="name">
        <label for="name"></label>
        <input
          type="text"
          placeholder="Namn"
          name="name"
          id="name_input"
          v-model="name"
          required
        />
      </div>
      <div class="email">
        <label for="email"></label>
        <input
          type="email"
          placeholder="E-mail"
          name="email"
          id="email_input"
          v-model="email"
          required
        />
      </div>
      <div class="message">
        <label for="message"></label>
        <textarea
          name="message"
          placeholder="Meddelande"
          id="message_input"
          cols="30"
          rows="5"
          v-model="message"
          required
        ></textarea>
      </div>
      <div class="submit">
        <button type="submit" id="form_button" >Skicka Meddelande</button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: '',
      email: '',
      message: '',
    };
  },
  methods: {
    async onSubmit() {
      console.log(`Name: ${this.name},  email: ${this.email}`);
      console.log(`subject: ${this.subject}`);
      console.log(`message: ${this.message}`);

      this.$notify({
        title: 'Mail skickat',
        text: 'Tack för ditt meddelande 😊',
        type: 'success',
      });
    },
  },
};
</script>

<style scoped>
button,
select {
  text-transform: none;
}

.submit {
  margin-top: 40px;
}

button,
input,
select,
textarea {
  color: #5a5a5a;
  font: inherit;
  margin: 20px 0;
}

input {
  line-height: normal;
}

textarea {
  overflow: auto;
}

.container {
  border: solid 3px #474544;
  max-width: 768px;
  margin: 60px auto;
  position: relative;
  background-color: rgb(255, 249, 239);
  text-align: center;
}
.container h1 {
  margin-top: 20px;
}

form {
  padding: 37.5px;
  margin: 50px 0 0 0;
}

h1.SectionHeader {
  color: #474544;
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 7px;
  text-align: center;
  text-transform: uppercase;
}

h1.ContactSectionHeader {
  color: white;
  text-align: center;
  padding-top: 200px;
  padding-bottom: 100px;
  font-size: 100px;
  font-weight: 200;
  letter-spacing: 40px;
  text-shadow: 0px 3px 3px black;
}

.ContactSection {
  min-height: 600px;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding-bottom: 100px;
}

.underline {
  border-bottom: solid 2px #474544;
  margin: 30px auto;
  width: 300px;
}

.email {
  width: 45%;
  float: right;
}

.message {
  float: none;
}

.name {
  float: left;
  width: 45%;
}

.subject {
  width: 100%;
}

textarea {
  margin-top: 20px;
  line-height: 150%;
  height: 150px;
  resize: none;
  width: 100%;
}

#form_button {
  background: none;
  border: solid 2px #474544;
  color: #474544;
  cursor: pointer;
  display: inline-block;
  font-family: "Helvetica", Arial, sans-serif;
  font-size: 0.875em;
  font-weight: bold;
  outline: none;
  padding: 20px 35px;
  text-transform: uppercase;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

#form_button:hover {
  background: #474544;
  color: #f2f3eb;
}
</style>
